import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=3c94d8f6&"
import script from "./FormError.vue?vue&type=script&lang=ts&"
export * from "./FormError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports